import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import axios from "axios";

const QuotationListFilterModal = ({
  closeFilter,
  isQualifiedLeads,
  fetchQuotationList,
  setCurrentSelectedStage,
  currentSelectedStage
}) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));

  const userAccessGroup = currentUserObject[0].accessgrp;

  const currentDepartmentFromLocalStorage = localStorage.getItem(
    "currentSelectedDepartment"
  );

  const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

  let idOfSalesPersonToPassInAPI = empIDFromUserObjectInLocalStorage ; // filterObjectFromModal.task_salesperson earlier 

  let idOfCoordinatorToPassInAPI = empIDFromUserObjectInLocalStorage ;

  let idOfCreatorViewToPassInAPI = empIDFromUserObjectInLocalStorage ;

  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";

  const USER_ACCESS = CURRENT_USER_OBJECT[0]?.useraccess;
  if (USER_ACCESS.indexOf("ZK") !== -1) {
    console.log("String is present, that means salesperson view");
    // just pass sales person because OO is present
  } else {
    idOfSalesPersonToPassInAPI = "-";
  }

  if (USER_ACCESS.indexOf("ZL") !== -1) {
    console.log("String is present, that means cordinator view");
    // just pass sales person because OO is present
  } else {
    idOfCoordinatorToPassInAPI = "-";
  }

  if (USER_ACCESS.indexOf("ZM") !== -1) {
    console.log("String is present, that means creator view");
    // just pass sales person because OO is present
  } else {
    idOfCreatorViewToPassInAPI = "-";
  }

  const [selectedRange, setSelectedRange] = useState("");
  const [selectedLeadSource, setSelectedLeadSource] = useState("");
  const [createDate, setCreateDate] = useState("");
  const [coordinatorList, setCoordinatorList] = useState(null);
  const [salespersonList, setSalesPersonList] = useState(null);

  const todayDate = format(new Date(), "yyyy-MM-dd");




  const initialFilterObject = {
    fromDate: "1900-01-01",
    toDate: todayDate,
    task_creator_id: "-",
    task_owner_id: "-",
    free_text: "-",
  };

  const [filterValuesState, setFilterValuesState] =
    useState(initialFilterObject);

  const callCordinatorListAPI = () => {
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/COORDINATORLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setCoordinatorList([
          { EMP_ID: "GENERAL", NAME: "GENERAL" },
          ...res.data,
        ]);
      })
      .catch((err) => { });
  };

  const callSalesPersonListAPI = () => {
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setSalesPersonList(res.data);
      })
      .catch((err) => { });
  };

  useEffect(() => {
    callCordinatorListAPI();
    callSalesPersonListAPI();
  }, []);

  useEffect(() => {
    if (selectedRange === "custom") {
      setFilterValuesState({
        ...filterValuesState,
        fromDate:
          filterValuesState.fromDate === "1900-01-01"
            ? filterValuesState.toDate
            : filterValuesState.fromDate,
      });
    }
  }, [selectedRange]);

  const getPredefinedDate = (range) => {
    const today = new Date();
    if (range === "today") return today.toISOString().split("T")[0];
    if (range === "last_week") {
      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7);
      return lastWeek.toISOString().split("T")[0];
    }
    if (range === "last_month") {
      const lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);
      return lastMonth.toISOString().split("T")[0];
    }
    return "1900-01-01";
  };

  useEffect(() => {
    console.log("filter value state ", filterValuesState)

  }, [filterValuesState])

  return (
    <div
      // id="filterModal"
      className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center"
      style={{ zIndex: 70 }}
    >
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">Add Filters</h2>
          <div className="flex space-x-4">
            <button
              onClick={() => {
                fetchQuotationList(userAccessGroup, currentDepartmentFromLocalStorage, filterValuesState);
                closeFilter();
              }}
              className="text-blue-500 hover:underline text-sm"
            >
              Apply Filters
            </button>
            <button
              // onClick={handleResetFilters}
              onClick={() => {
                setFilterValuesState(initialFilterObject);
                fetchQuotationList(userAccessGroup, currentDepartmentFromLocalStorage, initialFilterObject);
              }}
              className="text-blue-500 hover:underline text-sm"
            >
              Clear All
            </button>
            <button
              onClick={() =>
                // document.getElementById("filterModal").classList.add("hidden")
                closeFilter()
              }
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
        </div>

        {/* Filters Section */}
        <div className="p-4 border rounded-lg shadow-md">
          <div className="flex justify-between items-center border-b pb-2">
            <span className="text-gray-700">Create Date</span>
            <select
              className="text-gray-500 text-sm border border-gray-300 rounded px-2 py-1"
              value={selectedRange}
              onChange={(e) => setSelectedRange(e.target.value)}
            >
              <option value="">Select</option>
              <option value="today">Today</option>
              <option value="last_week">Last Week</option>
              <option value="last_month">Last Month</option>
              <option value="custom">Custom</option>
            </select>
          </div>

          {selectedRange === "custom" && (
            <div className="mt-2 flex gap-2">
              <input
                type="date"
                className="border border-gray-300 rounded px-2 py-1 text-sm"
                value={filterValuesState.fromDate}
                onChange={(e) =>
                  setFilterValuesState({
                    ...filterValuesState,
                    fromDate: e.target.value,
                  })
                }
              />
              <input
                type="date"
                className="border border-gray-300 rounded px-2 py-1 text-sm"
                value={filterValuesState.toDate}
                onChange={(e) =>
                  setFilterValuesState({
                    ...filterValuesState,
                    toDate: e.target.value,
                  })
                }
              />
            </div>
          )}

          {/* Lead Stage */}
          
            <div className="flex justify-between items-center border-b pb-2">
              <span className="text-gray-700">Stage</span>
              <select
                className="text-gray-500 text-sm border border-gray-300 rounded px-2 py-1 max-w-[100px]"
                value={currentSelectedStage}
                onChange={(e) => setCurrentSelectedStage(e.target.value)}
              >
                <option value="-">All</option>
                <option value="Draft">Draft</option>
                <option value="For Approval">For Approval</option>
                <option value="Approved">Approved</option>
                <option value="Customer Submission & Awaiting Approval">Customer Submission & Awaiting Approval</option>
                <option value="Customer Approval">Customer Approval</option>
                <option value="Customer Negotiation">Customer Negotiation</option>
                <option value="Lost-Customer Rejection">Customer Rejection</option>
                

               

              </select>
            </div>
        

          {/* Lead Status */}
          {/* {!isQualifiedLeads && (
            <div className="flex justify-between items-center border-b pb-2 mt-2">
              <span className="text-gray-700">Lead Status</span>
              <select
                className="text-gray-500 text-sm border border-gray-300 rounded px-2 py-1"
                value={filterValuesState.lead_status}
                onChange={(e) =>
                  setFilterValuesState({
                    ...filterValuesState,
                    lead_status: e.target.value,
                  })
                }
              >
                <option value="">Select</option>
                <option value="newLead">New Lead</option>
                <option value="contacted">Contacted</option>
                <option value="attemptedToContact">Attempted To Contact</option>
                <option value="unQualified">Unqualified</option>
              </select>
            </div>
          )} */}

          {/* Lead Source */}
          {/* <div className="flex justify-between items-center border-b pb-2">
            <span className="text-gray-700">Lead Source</span>
            <select
              className="text-gray-500 text-sm border border-gray-300 rounded px-2 py-1"
              value={selectedLeadSource}
              onChange={(e) => setSelectedLeadSource(e.target.value)}
            >
              <option value="">Select</option>
              <option value="walkin">Walk-in</option>
              <option value="phone">Phone</option>
              <option value="whatsapp">Whatsapp</option>
              <option value="email">E-mail</option>
              <option value="online">Online</option>
              <option value="otherSource">Others</option>
            </select>
          </div> */}

          {/* {(userAccessGroup?.trim().toUpperCase() === "ADMIN" || userAccessGroup?.trim().toUpperCase() === "CADMIN" || userAccessGroup?.trim().toUpperCase() === "COORDINATOR") && (
            <div className="flex justify-between items-center border-b pb-2">
              <span className="text-gray-700">Coordinator</span>
              <select
                className="text-gray-500 text-sm border border-gray-300 rounded px-2 py-1"
                value={filterValuesState.task_creator_id}
                onChange={(e) =>
                  setFilterValuesState({
                    ...filterValuesState,
                    task_creator_id: e.target.value?.trim(),
                  })
                }
              >
                <option value="">Select Coordinator</option>
                {coordinatorList?.map((item) => {
                  return <option value={item.EMP_ID}>{item.NAME}</option>;
                })}
              </select>
            </div>
          )} */}


{(USER_ACCESS.indexOf("ZM") !== -1)  ? null : 
              <div className="flex justify-between items-center border-b pb-2">
                <span className="text-gray-700">Creator</span>
                <select
                  className="text-gray-500 text-sm border border-gray-300 rounded px-2 py-1"
                  value={filterValuesState.task_creator_id}
                  onChange={(e) =>
                    setFilterValuesState({
                      ...filterValuesState,
                      task_creator_id: e.target.value?.trim(),
                    })
                  }
                >
                  <option value="">Select Creator</option>
                  {salespersonList?.map((item) => {
                    return <option value={item.EMP_ID}>{item.NAME}</option>;
                  })}
                </select>
              </div>
}

          {(USER_ACCESS.indexOf("ZK") !== -1)  ? null : 
              <div className="flex justify-between items-center border-b pb-2">
                <span className="text-gray-700">Salesperson</span>
                <select
                  className="text-gray-500 text-sm border border-gray-300 rounded px-2 py-1"
                  value={filterValuesState.task_owner_id}
                  onChange={(e) =>
                    setFilterValuesState({
                      ...filterValuesState,
                      task_owner_id: e.target.value?.trim(),
                    })
                  }
                >
                  <option value="">Select Salesperson</option>
                  {salespersonList?.map((item) => {
                    return <option value={item.EMP_ID}>{item.NAME}</option>;
                  })}
                </select>
              </div>
}
            
        </div>
      </div>
    </div>
  );
};

export default QuotationListFilterModal;
